export const MIN_HEADER_WIDTH = 110
export const MIN_RESIZED_WIDTH = 20

export const DEFAULT_CONFIG_NAME = 'Untitled Pivot'

export const GRAND_TOTAL_CAPTION = 'Grand total'
